/*
 * Stocking designer, a Shopify theme section (sections/stocking-designer.liquid).
 * Reads its data from <script type="application/json" data-skd-config> written by the section
 * and renders everything into [data-skd-app].
 * Designs come from the "stocking_design" metaobject entries; built-in designs fill in if none are set up.
 * Cart: in "event" mode each fabric is added as one continuous Measura cut (see measuraLine).
 * Holiday chips and tag search: section settings "Holiday chips" and "Holiday selected when the page opens",
 * or a link such as ?holiday=christmas.
 * Built from the shared design-tool source.
 */
(function () {
  'use strict';

  // ===================== shared designer core =====================
  // Same code in all the design tools (quilt, table runner, bag, stocking). Only the prefix differs.
  var FR = ['', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞'];
  var SVGNS = 'http://www.w3.org/2000/svg';
  var SEAM = 'rgba(20,20,20,.28)';
  var MONO = 'font-family="ui-monospace, Menlo, monospace"';
  var LABEL = 'fill="rgba(240,232,160,.85)" ' + MONO + ' text-anchor="middle"';
  var TAG_FAMILY = {
    white: 'light', cream: 'light', ivory: 'light', tan: 'brown', brown: 'brown', beige: 'brown',
    reds: 'red', red: 'red', pink: 'red', orange: 'orange', peaches: 'orange', peach: 'orange', rust: 'orange',
    gold: 'gold', yellow: 'gold', greens: 'green', green: 'green', blues: 'blue', blue: 'blue', teal: 'blue',
    purple: 'purple', black: 'grey', grey: 'grey', gray: 'grey', multi: 'print'
  };
  var FAMILIES = [
    ['all', 'All', null], ['light', 'Whites & creams', '#f3efe4'], ['brown', 'Tans & browns', '#9b7650'],
    ['red', 'Reds & pinks', '#c83a3a'], ['orange', 'Oranges', '#ee8a4a'], ['gold', 'Golds & yellows', '#e5c05a'],
    ['green', 'Greens', '#8fb77a'], ['blue', 'Blues', '#3d5f9a'], ['purple', 'Purples', '#8b7bc4'],
    ['grey', 'Greys & blacks', '#7d7f80'], ['print', 'Multi & prints', '#555'], ['solid', 'Solids only', null]
  ];
  var DEFAULT_HOLIDAYS = "Valentine's Day = holiday_valentines\nEaster = holiday_easter\nFourth of July = holiday_patriotic\nThanksgiving = holiday_thanksgiving\nChristmas = holiday_christmas";

  // ---------- helpers ----------
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtYd(y, step) {
    step = step || 8;
    var e = Math.max(1, Math.ceil(y * step - 1e-9)) * (8 / step);
    var w = Math.floor(e / 8), f = e % 8;
    return (w ? w + (f ? ' ' : '') : '') + FR[f] + ' yd';
  }
  function inch(v) { // 1.25 → 1¼″
    var w = Math.floor(v + 1e-9), f = Math.round((v - w) * 8);
    return (w ? String(w) : '') + FR[f] + '″';
  }
  function formatMoney(cents, format) {
    format = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    function fmt(n, dec, thou, decSep) {
      var fixed = (n / 100).toFixed(dec).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return whole + (dec ? decSep + fixed[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }
  function area(p) {
    var a = 0;
    for (var i = 0; i < p.length; i++) {
      var q = p[i], r = p[(i + 1) % p.length];
      a += q[0] * r[1] - r[0] * q[1];
    }
    return Math.abs(a) / 2;
  }
  // Finished piece grown by the seam allowance on every side (mitered corners).
  function cutArea(p, d) {
    d = d == null ? 0.25 : d;
    var per = 0, cot = 0, n = p.length;
    for (var i = 0; i < n; i++) {
      var a = p[(i + n - 1) % n], b = p[i], c = p[(i + 1) % n];
      per += Math.hypot(c[0] - b[0], c[1] - b[1]);
      var v1 = [a[0] - b[0], a[1] - b[1]], v2 = [c[0] - b[0], c[1] - b[1]];
      var cos = (v1[0] * v2[0] + v1[1] * v2[1]) / (Math.hypot(v1[0], v1[1]) * Math.hypot(v2[0], v2[1]));
      var th = Math.acos(Math.max(-1, Math.min(1, cos)));
      cot += 1 / Math.tan(th / 2);
    }
    return area(p) + per * d + d * d * cot;
  }
  function centroid(p) {
    var x = 0, y = 0;
    p.forEach(function (q) { x += q[0]; y += q[1]; });
    return [x / p.length, y / p.length];
  }
  function pathD(p) {
    return 'M' + p.map(function (q) { return q[0] + ' ' + q[1]; }).join('L') + 'Z';
  }
  function rectP(x, y, w, h) { return [[x, y], [x + w, y], [x + w, y + h], [x, y + h]]; }
  function b64urlEncode(obj) {
    var s = btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    return s.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(s) {
    try {
      s = s.replace(/-/g, '+').replace(/_/g, '/');
      while (s.length % 4) s += '=';
      return JSON.parse(decodeURIComponent(escape(atob(s))));
    } catch (e) { return null; }
  }
  // "Andover Century Solids" → "Century Solids" when the vendor is Andover.
  function stripMaker(title, vendor) {
    title = String(title || '');
    if (vendor && title.toLowerCase().indexOf(String(vendor).toLowerCase() + ' ') === 0) {
      var rest = title.slice(String(vendor).length + 1).replace(/^[\s\-–—:·]+/, '');
      if (rest) return rest;
    }
    return title;
  }
  // For search and holiday links: lower case, no apostrophes.
  function norm(s) { return String(s || '').toLowerCase().replace(/['’‘`]/g, ''); }
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function parseJson(v) {
    if (v == null || v === '') return null;
    if (typeof v === 'object') return v;
    try { return JSON.parse(v); } catch (e) { return null; }
  }
  // Slots may be [{id,name,role}] or [[id,name,role]].
  function normSlots(list) {
    if (!Array.isArray(list)) return null;
    var out = list.map(function (s) {
      if (Array.isArray(s)) return { id: String(s[0]), name: s[1] || String(s[0]), role: s[2] || 'any' };
      if (s && s.id) return { id: String(s.id), name: s.name || String(s.id), role: s.role || 'any' };
      return null;
    });
    return out.every(Boolean) && out.length ? out : null;
  }
  function validPieces(list) {
    return Array.isArray(list) && list.length && list.every(function (pc) {
      return pc && pc.s && Array.isArray(pc.p) && pc.p.length >= 3;
    });
  }
  // Holiday chips: one per line, "Chip name = tag".
  function parseHolidays(text) {
    var seen = {};
    return String(text == null ? DEFAULT_HOLIDAYS : text).split(/\r?\n/).map(function (line) {
      var i = line.lastIndexOf('=');
      if (i < 1) return null;
      var name = line.slice(0, i).trim(), tag = line.slice(i + 1).trim().toLowerCase();
      if (!name || !tag || seen[tag]) return null;
      seen[tag] = true;
      return { name: name, tag: tag };
    }).filter(Boolean);
  }

  function prepFabrics(raw, cfg) {
    var perYard = cfg.cartMode === 'quarter_units' ? 4 : 1;
    return (raw || []).filter(function (f) { return f && f.available && f.variantId; }).map(function (f) {
      var tags = (f.tags || []).map(function (t) { return String(t).toLowerCase(); });
      var fam = null;
      tags.forEach(function (t) {
        if (!fam && t.indexOf('color_') === 0) fam = TAG_FAMILY[t.slice(6)] || null;
      });
      if (!fam && tags.some(function (t) { return /^theme_/.test(t); })) fam = 'print';
      var img = f.image ? (f.image.indexOf('//') === 0 ? 'https:' + f.image : f.image) : null;
      return {
        key: String(f.id),
        sku: f.sku || '',
        name: stripMaker(f.title, f.vendor),
        vendor: f.vendor || '',
        url: f.url,
        variantId: f.variantId,
        pricePerYard: (f.price || 0) * perYard, // cents
        img: img,
        tags: tags,
        sw: Math.max(1, parseFloat(f.swatchWidth) || parseFloat(cfg.defaultSwatchWidth) || 6),
        fam: fam || 'print',
        solid: /\bsolids?\b/i.test(f.title),
        tracked: !!f.tracked,
        stockYards: f.tracked ? Math.max(0, f.stock || 0) / perYard : Infinity
      };
    });
  }

  // ---------- the component ----------
  // spec = what makes this designer a quilt / runner / bag / stocking designer (see the bottom of the file).
  function Designer(root, spec) {
    var cfgEl = root.querySelector('[data-skd-config]');
    this.spec = spec;
    this.root = root;
    this.app = root.querySelector('[data-skd-app]');
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) {
      this.app.innerHTML = '<p class="skd-loading">The ' + spec.noun + ' designer couldn’t read its settings.</p>';
      return;
    }
    this.sid = String(this.cfg.sectionId || Math.random().toString(36).slice(2)).replace(/[^\w-]/g, '');
    this.fabrics = prepFabrics(this.cfg.fabrics, this.cfg);
    this.designs = this.prepDesigns(this.cfg.designs);
    this.byKey = {};
    this.bySku = {};
    var self = this;
    this.fabrics.forEach(function (f) { self.byKey[f.key] = f; if (f.sku) self.bySku[f.sku.toUpperCase()] = f; });
    var present = {};
    this.fabrics.forEach(function (f) { f.tags.forEach(function (t) { present[t] = true; }); });
    this.holidays = parseHolidays(this.cfg.holidayChips).filter(function (h) { return present[h.tag]; });
    this.fabrics.forEach(function (f) {
      var hol = self.holidays.filter(function (h) { return f.tags.indexOf(h.tag) > -1; }).map(function (h) { return h.name; });
      f.hay = norm([f.name, f.vendor, f.sku, f.tags.join(' '), hol.join(' ')].join(' '));
    });
    if (spec.setup) spec.setup.call(this);

    if (!this.fabrics.length || !this.designs.length) {
      this.app.innerHTML = '<p class="skd-loading">' + (!this.designs.length
        ? 'No ' + spec.noun + ' designs have been set up yet.'
        : 'No fabrics are available for the designer right now.') + '</p>';
      return;
    }
    this.patterns = {};
    this.state = this.initialState();
    this.applyUrlState();
    this.buildShell();
    this.bind();
    this.renderAll();
  }
  var P = Designer.prototype;

  // Designs from the metaobject entries; built-in ones fill any gaps (and stand in when none are set up).
  P.prepDesigns = function (raw) {
    var spec = this.spec, cfg = this.cfg, out = [], used = {};
    (raw || []).forEach(function (d) {
      if (!d) return;
      var g = parseJson(d.geometry), dflt = parseJson(d.defaults) || {};
      var builtin = spec.builtin.filter(function (b) {
        return b.id === d.id || slug(b.name) === slug(d.name) || (b.aliases || []).indexOf(d.id) > -1;
      })[0];
      var des = spec.prepGeometry(g) || (builtin && spec.prepGeometry(builtin.geometry));
      if (!des) return;
      des.id = String(d.id || slug(d.name));
      des.name = d.name || (builtin && builtin.name) || des.id;
      des.skill = d.skill || (builtin && builtin.skill) || '';
      des.sort = Number(d.sort) || 0;
      des.defaults = {};
      Object.keys((builtin && builtin.defaults) || {}).forEach(function (k) { des.defaults[k] = builtin.defaults[k]; });
      Object.keys(dflt).forEach(function (k) { des.defaults[k] = dflt[k]; });
      if (builtin) used[builtin.id] = true;
      out.push(des);
    });
    if (!out.length && cfg.builtinFallback !== false) {
      spec.builtin.forEach(function (b, i) {
        var des = spec.prepGeometry(b.geometry);
        des.id = b.id; des.name = b.name; des.skill = b.skill || ''; des.sort = i + 1; des.defaults = b.defaults || {};
        out.push(des);
      });
    }
    return out.sort(function (a, b) { return a.sort - b.sort; });
  };

  P.design = function () {
    var id = this.state.design;
    return this.designs.filter(function (d) { return d.id === id; })[0] || this.designs[0];
  };
  P.pickFabric = function (role, i) {
    var pool = this.fabrics.filter(function (f) {
      return role === 'light' ? f.fam === 'light' : role === 'dark' ? /blue|purple|grey|brown|green/.test(f.fam) : f.fam !== 'light';
    });
    if (!pool.length) pool = this.fabrics;
    return pool[i % pool.length].key;
  };
  P.skuKey = function (sku) {
    var f = sku && this.bySku[String(sku).toUpperCase()];
    return f ? f.key : null;
  };
  P.designDefaults = function (d) {
    var self = this, out = {};
    d.slots.forEach(function (s, i) { out[s.id] = self.skuKey(d.defaults[s.id]) || self.pickFabric(s.role, i * 7 + 3); });
    return out;
  };
  // Finishing parts: design default (_border etc.), then the spec's fallback SKU, then a design fabric.
  P.finishDefaults = function (d, f0) {
    var self = this, out = {}, slots = d.slots;
    var light = slots.filter(function (s) { return s.role === 'light'; })[0] || slots[0];
    var dark = slots.filter(function (s) { return s.role === 'dark'; })[0] || slots[slots.length - 1];
    var second = slots[1] || slots[0];
    var pick = { light: light, dark: dark, second: second };
    this.spec.qslots.forEach(function (q) {
      out[q.id] = self.skuKey(d.defaults['_' + q.id]) || self.skuKey(q.sku) || f0[(pick[q.from] || second).id];
    });
    return out;
  };
  P.optDefault = function (o) {
    var v = this.cfg[o.cfgKey || ('default_' + o.id)];
    return o.values.indexOf(String(v)) > -1 ? String(v) : String(o.dflt);
  };
  P.initialState = function () {
    var self = this, cfg = this.cfg, spec = this.spec;
    var first = this.designs.filter(function (d) { return d.id === cfg.defaultDesign; })[0] || this.designs[0];
    var fab = {}, opt = {};
    this.designs.forEach(function (d) { fab[d.id] = self.designDefaults(d); });
    this.options().forEach(function (o) { opt[o.id] = self.optDefault(o); });
    var views = spec.views.map(function (v) { return v[0]; });
    var hol = this.findHoliday(cfg.holidayDefault);
    return {
      design: first.id,
      view: views.indexOf(cfg.defaultView) > -1 ? cfg.defaultView : spec.defaultView,
      opt: opt,
      fab: fab,
      q: this.finishDefaults(first, fab[first.id]),
      active: 'b:' + (first.slots[1] || first.slots[0]).id,
      hover: null, fam: 'all', hol: hol ? hol.tag : '', query: ''
    };
  };
  P.options = function () {
    var self = this;
    return this.spec.options.filter(function (o) { return !o.show || o.show.call(self); }).map(function (o) {
      var opts = typeof o.opts === 'function' ? o.opts.call(self) : o.opts;
      return { id: o.id, label: o.label, opts: opts, values: opts.map(function (x) { return String(x[0]); }), dflt: o.dflt, cfgKey: o.cfgKey, group: o.group };
    });
  };
  P.opt = function (id) { return this.state.opt[id]; };
  // "christmas", "holiday_christmas", "fourth-of-july" or "Fourth of July" all find the chip.
  P.findHoliday = function (v) {
    var s = slug(v);
    if (!s) return null;
    return this.holidays.filter(function (h) {
      var t = slug(h.tag);
      return t === s || t.replace(/^holiday-/, '') === s || slug(h.name) === s;
    })[0] || null;
  };

  // ---------- shareable URL ----------
  P.urlState = function () {
    var s = this.state, d = this.design();
    var o = { d: d.id, v: s.view, o: s.opt, f: s.fab[d.id], q: s.q };
    if (s.hol) o.y = s.hol;
    return o;
  };
  P.applyUrlState = function () {
    var params, raw, s = this.state, self = this;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var h = this.findHoliday(params.get('holiday'));
    if (h) s.hol = h.tag;
    raw = params.get(this.spec.param);
    if (!raw) return;
    var o = b64urlDecode(raw);
    if (!o) return;
    var d = this.designs.filter(function (x) { return x.id === o.d; })[0];
    if (!d) return;
    s.design = d.id;
    if (this.spec.views.some(function (v) { return v[0] === o.v; })) s.view = o.v;
    if (o.o) this.options().forEach(function (op) { if (op.values.indexOf(String(o.o[op.id])) > -1) s.opt[op.id] = String(o.o[op.id]); });
    var ok = function (k) { return k && self.byKey[k]; };
    if (o.f) d.slots.forEach(function (sl) { if (ok(o.f[sl.id])) s.fab[d.id][sl.id] = o.f[sl.id]; });
    if (o.q) this.spec.qslots.forEach(function (q) { if (ok(o.q[q.id])) s.q[q.id] = o.q[q.id]; });
    if (o.y) { var hy = this.findHoliday(o.y); if (hy) s.hol = hy.tag; }
    s.active = 'b:' + (d.slots[1] || d.slots[0]).id;
  };
  P.shareUrl = function () {
    var u = new URL(window.location.href);
    u.searchParams.delete('holiday');
    u.searchParams.set(this.spec.param, b64urlEncode(this.urlState()));
    return u.toString();
  };
  P.syncUrl = function () {
    try { window.history.replaceState(window.history.state, '', this.shareUrl()); } catch (e) { /* ignore */ }
  };

  // ---------- lookups ----------
  P.keyFor = function (slotKey) {
    var s = this.state;
    if (s.hover && slotKey === s.active) return s.hover;
    return this.storedKey(slotKey);
  };
  P.storedKey = function (slotKey) {
    var parts = slotKey.split(':');
    return parts[0] === 'b' ? this.state.fab[this.design().id][parts[1]] : this.state.q[parts[1]];
  };
  P.slotEnabled = function (k) {
    var p = k.split(':');
    if (p[0] === 'b') return true;
    var q = this.spec.qslots.filter(function (x) { return x.id === p[1]; })[0];
    return !q || !q.on || q.on.call(this);
  };
  P.slotName = function (k) {
    var p = k.split(':');
    if (p[0] === 'b') return (this.design().slots.filter(function (s) { return s.id === p[1]; })[0] || {}).name;
    return (this.spec.qslots.filter(function (s) { return s.id === p[1]; })[0] || {}).name;
  };
  P.money = function (cents) { return formatMoney(Math.round(cents), this.cfg.moneyFormat); };
  P.dims = function () { return this.spec.dims.call(this); };

  // Yardage: the spec adds pieces with put(); this rounds each fabric up.
  P.yardage = function () {
    var self = this, s = this.state;
    var WOF = Number(this.cfg.usableWidth) || 40, waste = 1 + (Number(this.cfg.wastePercent) || 0) / 100;
    var raw = {}, perSlot = {}, uses = {};
    function put(slotKey, yd) {
      if (!(yd > 0)) return;
      var key = self.storedKey(slotKey);
      raw[key] = (raw[key] || 0) + yd;
      perSlot[slotKey] = (perSlot[slotKey] || 0) + yd;
      var nm = self.slotName(slotKey);
      (uses[key] = uses[key] || []).indexOf(nm) < 0 && uses[key].push(nm);
    }
    // n rectangles (cut size w × h): rows across the fabric width, whichever way round uses less.
    function rects(w, h, n) {
      function rows(a, b) { if (a > WOF) return Infinity; return Math.ceil(n / Math.floor(WOF / a)) * b; }
      var r = Math.min(rows(w, h), rows(h, w));
      if (r === Infinity) r = n * Math.ceil(w / WOF) * h; // wider than the fabric: pieced
      return r / 36;
    }
    // Strips cut across the width of fabric for a total length (border, binding, sashing).
    function strips(totalLen, cutW) { return Math.ceil(totalLen / WOF - 1e-9) * cutW / 36; }
    // Pieced parts: sum of cut areas, plus the trimming allowance.
    function pieced(slotKey, cutAreaSqIn) { put(slotKey, cutAreaSqIn * waste / (WOF * 36)); }
    this.spec.yardage.call(this, { put: put, rects: rects, strips: strips, pieced: pieced, WOF: WOF, waste: waste });
    var whole = this.cfg.cartMode === 'yards';
    var buy = {};
    Object.keys(raw).forEach(function (k) {
      buy[k] = whole ? Math.max(1, Math.ceil(raw[k] - 1e-9)) : Math.max(0.25, Math.ceil(raw[k] * 4 - 1e-9) / 4);
    });
    return { buy: buy, perSlot: perSlot, uses: uses };
  };
  P.shortages = function (buy) {
    if (!this.cfg.showStock) return [];
    var self = this;
    return Object.keys(buy).filter(function (k) { return buy[k] > self.byKey[k].stockYards; });
  };

  // ---------- SVG helpers ----------
  P.pid = function (key) { return 'skd-' + this.sid + '-p-' + key; };
  P.ensurePattern = function (key) {
    if (this.patterns[key]) return;
    var f = this.byKey[key];
    if (!f) return;
    var W = f.sw, T = 2 * W;
    var p = document.createElementNS(SVGNS, 'pattern');
    p.setAttribute('id', this.pid(key));
    p.setAttribute('patternUnits', 'userSpaceOnUse');
    p.setAttribute('width', T);
    p.setAttribute('height', T);
    var html = '<rect width="' + T + '" height="' + T + '" fill="#c9c9c4"/>';
    if (f.img) {
      // Four mirrored copies hide the seams where the photo repeats.
      ['', 'translate(' + T + ' 0) scale(-1 1)', 'translate(0 ' + T + ') scale(1 -1)', 'translate(' + T + ' ' + T + ') scale(-1 -1)']
        .forEach(function (t) {
          html += '<image href="' + esc(f.img) + '" x="0" y="0" width="' + W + '" height="' + W + '" preserveAspectRatio="xMidYMid slice"' + (t ? ' transform="' + t + '"' : '') + '/>';
        });
    }
    p.innerHTML = html;
    this.defs.appendChild(p);
    this.patterns[key] = true;
  };
  P.fill = function (key) {
    this.ensurePattern(key);
    return 'url(#' + this.pid(key) + ')';
  };
  P.selStroke = function (sw) { return 'fill="none" stroke="var(--skd-thread)" stroke-width="' + sw + '" stroke-dasharray=".4 .25" pointer-events="none"'; };
  // Pieces of one unit at (tx, ty); rot = quarter turns about the unit's center.
  P.piecesSVG = function (pieces, tx, ty, opts) {
    opts = opts || {};
    var self = this, o = '', sel = '', act = this.state.active;
    var tr = 'translate(' + tx + ' ' + ty + ')' + (opts.rot ? ' rotate(' + 90 * opts.rot + ' ' + opts.cx + ' ' + opts.cy + ')' : '');
    pieces.forEach(function (pc) {
      var k = 'b:' + pc.s, key = opts.fabOf ? opts.fabOf(pc.s) : self.keyFor(k);
      o += '<path d="' + pathD(pc.p) + '" fill="' + self.fill(key) + '" stroke="' + SEAM + '" stroke-width="' + (opts.seam || 0.04) + '"' + (opts.click ? ' data-slot="' + k + '"' : '') + '/>';
      if (opts.click && k === act) sel += '<path d="' + pathD(pc.p) + '" ' + self.selStroke(opts.selW || 0.1) + '/>';
    });
    return { body: '<g transform="' + tr + '">' + o + '</g>', sel: sel ? '<g transform="' + tr + '">' + sel + '</g>' : '' };
  };
  P.badge = function (x, y, n, r) {
    return '<g pointer-events="none"><circle cx="' + x + '" cy="' + y + '" r="' + r + '" fill="#fff" stroke="#17211e" stroke-width="' + r * 0.12 + '"/><text x="' + x + '" y="' + (y + r * 0.36) + '" font-size="' + r * 1.05 + '" font-weight="700" text-anchor="middle" fill="#17211e" ' + MONO + '>' + n + '</text></g>';
  };
  P.matGrid = function (x0, y0, x1, y1, step, major) {
    var g = '', x, y, w = step * 0.035, W = step * 0.06;
    for (x = Math.ceil(x0 / step) * step; x <= x1; x += step) {
      var mx = Math.abs(x % major) < 1e-6;
      g += '<line x1="' + x + '" y1="' + y0 + '" x2="' + x + '" y2="' + y1 + '" stroke="' + (mx ? 'rgba(236,226,146,.5)' : 'rgba(255,255,255,.1)') + '" stroke-width="' + (mx ? W : w) + '"/>';
    }
    for (y = Math.ceil(y0 / step) * step; y <= y1; y += step) {
      var my = Math.abs(y % major) < 1e-6;
      g += '<line x1="' + x0 + '" y1="' + y + '" x2="' + x1 + '" y2="' + y + '" stroke="' + (my ? 'rgba(236,226,146,.5)' : 'rgba(255,255,255,.1)') + '" stroke-width="' + (my ? W : w) + '"/>';
    }
    return g;
  };
  P.mat = function (X0, Y0, VW, VH, step, major) {
    return '<rect x="' + (X0 - 60) + '" y="' + (Y0 - 60) + '" width="' + (VW + 120) + '" height="' + (VH + 120) + '" fill="var(--skd-mat)"/>' +
      this.matGrid(X0 - 60, Y0 - 60, X0 + VW + 60, Y0 + VH + 60, step, major);
  };

  // ---------- DOM ----------
  P.q = function (sel) { return this.app.querySelector(sel); };
  P.buildShell = function () {
    var id = this.sid, spec = this.spec, self = this;
    var controls = this.options().map(function (o) {
      var opts = '', groups = {};
      o.opts.forEach(function (x) {
        var html = '<option value="' + esc(x[0]) + '">' + esc(x[1]) + '</option>';
        if (x[2]) { if (!groups[x[2]]) { groups[x[2]] = []; } groups[x[2]].push(html); } else opts += html;
      });
      Object.keys(groups).forEach(function (g) { opts += '<optgroup label="' + esc(g) + '">' + groups[g].join('') + '</optgroup>'; });
      return '<label for="skd-' + o.id + '-' + id + '">' + esc(o.label) + '<select id="skd-' + o.id + '-' + id + '" data-skd-opt="' + o.id + '">' + opts + '</select></label>';
    }).join('');
    this.app.innerHTML =
      '<svg class="skd-defs" width="0" height="0" aria-hidden="true" focusable="false"><defs data-skd-defs></defs></svg>' +
      '<div class="skd-card skd-stage">' +
        '<div class="skd-blocks" data-skd-blocks role="group" aria-label="' + esc(spec.designsLabel) + '"></div>' +
        '<div class="skd-bar">' +
          '<div class="skd-seg" role="group" aria-label="View">' +
            spec.views.map(function (v) { return '<button type="button" data-skd-view="' + v[0] + '">' + esc(v[1]) + '</button>'; }).join('') +
          '</div>' +
          '<div class="skd-muted" data-skd-size></div>' +
        '</div>' +
        '<div class="skd-canvas" data-skd-canvas></div>' +
        '<div class="skd-controls" style="--skd-cols:' + Math.min(6, this.options().length) + '">' + controls + '</div>' +
        '<p class="skd-hint">' + esc(spec.hint) + '</p>' +
      '</div>' +
      '<div class="skd-layout">' +
        '<div class="skd-card skd-sec">' +
          '<div class="skd-sec-h"><h3 class="skd-h" data-skd-slots-title></h3>' +
            '<div class="skd-tools"><button type="button" class="skd-ghost" data-skd-surprise>Surprise me</button><button type="button" class="skd-ghost" data-skd-reset>Reset</button></div></div>' +
          '<div class="skd-slots" data-skd-slots></div>' +
          '<p class="skd-sub">' + esc(spec.qTitle) + '</p>' +
          '<div class="skd-slots" data-skd-qslots></div>' +
          '<div class="skd-picker">' +
            '<p class="skd-picker-h" data-skd-picker-h></p>' +
            '<label class="skd-visually-hidden" for="skd-search-' + id + '">Search fabrics</label>' +
            '<input class="skd-search" id="skd-search-' + id + '" type="search" placeholder="Search by name, maker, SKU or holiday" autocomplete="off" data-skd-search>' +
            '<div class="skd-chips" data-skd-chips role="group" aria-label="Filter by color"></div>' +
            '<div class="skd-hol" data-skd-hol-row' + (this.holidays.length ? '' : ' hidden') + '><span class="skd-hol-l">Holidays</span><div class="skd-chips" data-skd-hols role="group" aria-label="Filter by holiday"></div></div>' +
            '<div class="skd-grid" data-skd-grid></div>' +
          '</div>' +
        '</div>' +
        '<div class="skd-card skd-sec">' +
          '<div class="skd-sec-h"><h3 class="skd-h">Shopping list</h3><span class="skd-muted" data-skd-list-for></span></div>' +
          '<table class="skd-list"><tbody data-skd-list></tbody></table>' +
          '<div class="skd-totals"><span class="skd-muted" data-skd-tot-yd></span><span class="skd-big" data-skd-tot></span></div>' +
          '<div class="skd-warn" data-skd-warn hidden></div>' +
          '<button type="button" class="skd-cta" data-skd-add>Add all to cart</button>' +
          '<div class="skd-msg" data-skd-msg role="status" aria-live="polite" hidden></div>' +
          '<button type="button" class="skd-ghost skd-share" data-skd-share>Copy link to this design</button>' +
          '<p class="skd-note" data-skd-extra hidden></p>' +
          '<p class="skd-fine" data-skd-fine></p>' +
        '</div>' +
      '</div>';
    this.defs = this.q('[data-skd-defs]');
    this.buildGrid();
  };
  P.buildGrid = function () {
    var self = this, present = {};
    this.fabrics.forEach(function (f) { present[f.fam] = true; if (f.solid) present.solid = true; });
    this.q('[data-skd-chips]').innerHTML = FAMILIES.filter(function (x) { return x[0] === 'all' || present[x[0]]; }).map(function (x) {
      return '<button type="button" class="skd-chip" data-skd-fam="' + x[0] + '">' + (x[2] ? '<i style="background:' + x[2] + '"></i>' : '') + esc(x[1]) + '</button>';
    }).join('');
    this.q('[data-skd-hols]').innerHTML = this.holidays.map(function (h) {
      return '<button type="button" class="skd-chip" data-skd-holiday="' + esc(h.tag) + '">' + esc(h.name) + '</button>';
    }).join('');
    this.q('[data-skd-grid]').innerHTML = this.fabrics.map(function (f) {
      var low = self.cfg.showStock && f.tracked && f.stockYards < 3;
      return '<button type="button" class="skd-fab" data-skd-fabric="' + f.key + '" title="' + esc(f.name + (f.vendor ? ' by ' + f.vendor : '') + (f.sku ? ' · ' + f.sku : '')) + '">' +
        '<span class="skd-sw"' + (f.img ? ' style="background-image:url(\'' + esc(f.img) + '\')"' : '') + '></span>' +
        '<b>' + esc(f.name) + '</b><small>' + self.money(f.pricePerYard) + '/yd' + (low ? ' · ' + fmtYd(f.stockYards, 4) + ' left' : '') + '</small></button>';
    }).join('') + '<p class="skd-empty" data-skd-nohits hidden>No fabrics match. Try another color or holiday, or clear the search.</p>';
  };
  P.swatch = function (key, cls) {
    var f = this.byKey[key];
    return '<span class="' + cls + '"' + (f && f.img ? ' style="background-image:url(\'' + esc(f.img) + '\')"' : '') + '></span>';
  };
  P.renderBlocks = function () {
    var self = this, cur = this.design().id;
    this.q('[data-skd-blocks]').innerHTML = this.designs.map(function (d) {
      return '<button type="button" class="skd-blk" data-skd-design="' + esc(d.id) + '" aria-pressed="' + (d.id === cur) + '">' + self.spec.miniSVG.call(self, d) +
        '<span>' + esc(d.name) + '</span>' + (d.skill ? '<small>' + esc(d.skill) + '</small>' : '') + '</button>';
    }).join('');
  };
  P.renderStage = function () {
    this.q('[data-skd-canvas]').innerHTML = this.spec.render.call(this, this.state.view);
  };
  P.renderSlots = function () {
    var self = this, des = this.design(), y = this.yardage(), s = this.state;
    this.q('[data-skd-slots-title]').textContent = des.name + ' fabrics';
    this.q('[data-skd-slots]').innerHTML = des.slots.map(function (sl, i) {
      var k = 'b:' + sl.id, f = self.byKey[s.fab[des.id][sl.id]];
      return '<button type="button" class="skd-slot" data-skd-slot="' + k + '" aria-pressed="' + (k === s.active) + '"><span class="skd-num">' + (i + 1) + '</span>' + self.swatch(f.key, 'skd-sw') +
        '<span class="skd-t"><strong>' + esc(sl.name) + '</strong><small>' + esc(f.name) + (f.vendor ? ' · ' + esc(f.vendor) : '') + '</small></span><span class="skd-yd">' + fmtYd(y.perSlot[k] || 0) + '</span></button>';
    }).join('');
    this.q('[data-skd-qslots]').innerHTML = this.spec.qslots.map(function (qs) {
      var k = 'q:' + qs.id, f = self.byKey[s.q[qs.id]], en = self.slotEnabled(k);
      var sub = en ? esc(f.name) + (f.vendor ? ' · ' + esc(f.vendor) : '') : esc(qs.off || 'Not used');
      return '<button type="button" class="skd-slot" data-skd-slot="' + k + '" aria-pressed="' + (k === s.active) + '"' + (en ? '' : ' disabled') + '><span class="skd-num skd-num--q">' + esc(qs.name[0]) + '</span>' + self.swatch(f.key, 'skd-sw') +
        '<span class="skd-t"><strong>' + esc(qs.name) + '</strong><small>' + sub + '</small></span><span class="skd-yd">' + (en ? fmtYd(y.perSlot[k] || 0) : '') + '</span></button>';
    }).join('');
  };
  P.fabricShown = function (f) {
    var s = this.state;
    if (s.fam !== 'all' && !(s.fam === 'solid' ? f.solid : f.fam === s.fam)) return false;
    if (s.hol && f.tags.indexOf(s.hol) < 0) return false;
    var words = norm(s.query).split(/\s+/).filter(Boolean);
    return words.every(function (w) { return f.hay.indexOf(w) > -1; });
  };
  P.renderPicker = function () {
    var s = this.state, hits = 0, self = this;
    var cur = this.storedKey(s.active);
    this.q('[data-skd-picker-h]').innerHTML = 'Choose fabric for <b>' + esc(this.slotName(s.active)) + '</b>';
    this.app.querySelectorAll('[data-skd-fabric]').forEach(function (el) {
      var f = self.byKey[el.getAttribute('data-skd-fabric')];
      el.hidden = !self.fabricShown(f);
      if (!el.hidden) hits++;
      el.setAttribute('aria-pressed', String(f.key === cur));
    });
    this.q('[data-skd-nohits]').hidden = hits > 0;
    this.app.querySelectorAll('[data-skd-fam]').forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-skd-fam') === s.fam)); });
    this.app.querySelectorAll('[data-skd-holiday]').forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-skd-holiday') === s.hol)); });
  };
  P.renderList = function () {
    var self = this, y = this.yardage(), buy = y.buy, spec = this.spec;
    var short = this.shortages(buy);
    var step = this.cfg.cartMode === 'yards' ? 1 : 4;
    this.q('[data-skd-list-for]').textContent = spec.sizeText.call(this);
    this.q('[data-skd-size]').innerHTML = spec.sizeHead.call(this);
    var keys = Object.keys(buy).sort(function (a, b) { return buy[b] - buy[a]; });
    var tot = 0, yd = 0;
    this.q('[data-skd-list]').innerHTML = keys.map(function (k) {
      var f = self.byKey[k], cost = buy[k] * f.pricePerYard, isShort = short.indexOf(k) > -1;
      tot += cost; yd += buy[k];
      return '<tr' + (isShort ? ' class="skd-short"' : '') + '><td class="skd-mini-td">' + self.swatch(k, 'skd-mini') + '</td><td><a class="skd-nm" href="' + esc(f.url) + '">' + esc(f.name) + '</a><div class="skd-sk">' + esc([f.vendor, f.sku].filter(Boolean).join(' · ')) + '</div>' +
        '<div class="skd-sk">For: ' + esc(y.uses[k].join(', ')) + '</div>' +
        (isShort ? '<div class="skd-sk skd-sk--warn">Only ' + fmtYd(f.stockYards, 4) + ' in stock</div>' : '') +
        '</td><td class="skd-r">' + fmtYd(buy[k], step) + '</td><td class="skd-r">' + self.money(cost) + '</td></tr>';
    }).join('');
    this.q('[data-skd-tot-yd]').textContent = keys.length + ' fabrics · ' + fmtYd(yd, step);
    this.q('[data-skd-tot]').textContent = this.money(tot);
    var add = this.q('[data-skd-add]'), warn = this.q('[data-skd-warn]');
    if (short.length) {
      warn.hidden = false;
      warn.textContent = 'Not enough in stock: ' + short.map(function (k) { return self.byKey[k].name + ' (' + y.uses[k].join(', ') + ')'; }).join('; ') + '. Choose another fabric for those parts to continue.';
      add.disabled = true;
      add.textContent = 'Choose fabrics that are in stock';
    } else {
      warn.hidden = true;
      add.disabled = false;
      add.textContent = 'Add all ' + keys.length + ' to cart · ' + this.money(tot);
    }
    var extra = spec.extraNote ? spec.extraNote.call(this) : '';
    var ex = this.q('[data-skd-extra]');
    ex.hidden = !extra; ex.textContent = extra;
    this.q('[data-skd-fine]').textContent = 'Yardage includes ¼″ seams, about ' + (Number(this.cfg.wastePercent) || 0) + '% extra for trimming the pieced parts and a ' +
      (Number(this.cfg.usableWidth) || 40) + '″ usable width, rounded up to the next ' + (step === 1 ? 'yard' : '¼ yard') + '. ' + spec.fineText.call(this) +
      (step === 1 ? '' : ' Each fabric is cut in one continuous piece from the bolt.');
  };
  P.renderControls = function () {
    var s = this.state;
    this.app.querySelectorAll('[data-skd-view]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-skd-view') === s.view)); });
    this.app.querySelectorAll('[data-skd-opt]').forEach(function (el) { el.value = String(s.opt[el.getAttribute('data-skd-opt')]); });
  };
  P.renderAll = function () {
    this.renderBlocks(); this.renderStage(); this.renderSlots(); this.renderPicker(); this.renderList(); this.renderControls();
    this.syncUrl();
  };

  // ---------- actions ----------
  P.fallback = function () {
    if (!this.slotEnabled(this.state.active)) this.state.active = 'b:' + this.design().slots[0].id;
  };
  P.setActive = function (k) {
    if (!this.slotEnabled(k)) return;
    this.state.active = k; this.state.hover = null;
    this.renderStage(); this.renderSlots(); this.renderPicker();
  };
  P.setFabric = function (key) {
    var p = this.state.active.split(':');
    if (p[0] === 'b') this.state.fab[this.design().id][p[1]] = key; else this.state.q[p[1]] = key;
    this.state.hover = null;
    this.renderAll();
  };
  P.pools = function () {
    var self = this;
    function pool(fn) { var p = self.fabrics.filter(fn); return p.length ? p : self.fabrics; }
    // "Surprise me" stays inside the chosen holiday, if there are enough fabrics for it.
    var hol = this.state.hol, base = function (f) { return true; };
    if (hol && this.fabrics.filter(function (f) { return f.tags.indexOf(hol) > -1; }).length >= 3) base = function (f) { return f.tags.indexOf(hol) > -1; };
    return {
      light: pool(function (f) { return base(f) && f.fam === 'light'; }),
      dark: pool(function (f) { return base(f) && /blue|purple|grey|brown|green/.test(f.fam); }),
      mid: pool(function (f) { return base(f) && f.fam !== 'light'; })
    };
  };
  P.surprise = function () {
    var des = this.design(), used = {}, s = this.state, pools = this.pools();
    function take(p) {
      var f, t = 0;
      do { f = p[Math.floor(Math.random() * p.length)]; t++; } while (used[f.key] && t < 40);
      used[f.key] = true; return f.key;
    }
    function any(arr, dflt) { return arr.length ? arr[Math.floor(Math.random() * arr.length)] : dflt; }
    des.slots.forEach(function (sl) {
      s.fab[des.id][sl.id] = take(sl.role === 'light' ? pools.light : sl.role === 'dark' ? pools.dark : pools.mid);
    });
    var accents = des.slots.filter(function (sl) { return sl.role !== 'light'; }).map(function (sl) { return s.fab[des.id][sl.id]; });
    var lights = des.slots.filter(function (sl) { return sl.role === 'light'; }).map(function (sl) { return s.fab[des.id][sl.id]; });
    this.spec.surpriseFinish.call(this, { take: take, any: any, accents: accents, lights: lights, pools: pools });
    this.renderAll();
  };
  P.reset = function () {
    var keep = { design: this.state.design, view: this.state.view, opt: this.state.opt, hol: this.state.hol };
    this.state = this.initialState();
    this.state.design = keep.design; this.state.view = keep.view; this.state.opt = keep.opt; this.state.hol = keep.hol;
    var d = this.design();
    this.state.q = this.finishDefaults(d, this.state.fab[d.id]);
    this.state.active = 'b:' + (d.slots[1] || d.slots[0]).id;
    this.fallback();
    var search = this.q('[data-skd-search]'); if (search) search.value = '';
    this.renderAll();
  };
  P.message = function (html, isError) {
    var m = this.q('[data-skd-msg]');
    m.hidden = false;
    m.className = 'skd-msg' + (isError ? ' skd-msg--err' : '');
    m.innerHTML = html;
  };
  P.cartItems = function () {
    var self = this, y = this.yardage(), des = this.design(), mode = this.cfg.cartMode, label = this.spec.sizeText.call(this);
    return Object.keys(y.buy).map(function (k) {
      var f = self.byKey[k], yd = y.buy[k], props = {};
      props[self.spec.propLabel] = des.name + ', ' + label;
      props['Used for'] = y.uses[k].join(', ');
      return {
        id: f.variantId,
        key: k,
        quantity: mode === 'quarter_units' ? Math.round(yd * 4) : Math.ceil(yd - 1e-9),
        yards: yd,
        properties: props
      };
    });
  };
  // Measura line: one continuous piece (quantity 1) of the full length, priced per yard by Measura
  // from these properties. Format observed on the demo store, 2026-09-25. Re-test after Measura updates.
  P.measuraLine = function (item, n) {
    var f = this.byKey[item.key], yd = item.yards;
    var unitPrice = this.money(f.pricePerYard) + ' / yd';
    var props = {
      'Net length': yd + ' yd',
      'Unit price': unitPrice,
      '_measura_data': JSON.stringify({
        p: {}, pi: 0, u: unitPrice,
        m: { d: [{ v: yd, u: 'yd' }] },
        measurement: { type: 'length', dimensions: [{ unit: 'yd', value: yd }] },
        um: { v: 1, u: 'yd' }
      }),
      '_measura_item_id': String(Date.now() * 1000 + n * 97 + Math.floor(Math.random() * 97))
    };
    Object.keys(item.properties).forEach(function (k) { props[k] = item.properties[k]; });
    return { id: item.id, quantity: 1, properties: props };
  };
  P.linkList = function (items) {
    var self = this;
    return '<ul class="skd-links">' + items.map(function (i) {
      var f = self.byKey[i.key];
      return '<li><a href="' + esc(f.url) + '" target="_blank" rel="noopener">' + esc(f.name) + (f.sku ? ' <span class="skd-sk">' + esc(f.sku) + '</span>' : '') + '</a><b>' + fmtYd(i.yards, 4) + '</b></li>';
    }).join('') + '</ul>';
  };
  P.addToCart = function () {
    var self = this, btn = this.q('[data-skd-add]'), ev0 = this.spec.event;
    var items = this.cartItems(), lines;
    if (this.cfg.cartMode === 'event') {
      // Other code can take over by calling preventDefault() on this event.
      var ev = new CustomEvent(ev0 + ':add', {
        bubbles: true, cancelable: true,
        detail: { items: items, design: this.design().id, size: this.spec.sizeText.call(this), shareUrl: this.shareUrl() }
      });
      this.root.dispatchEvent(ev);
      if (ev.defaultPrevented) { this.message('Adding your fabrics…'); return; }
      lines = items.map(function (i, n) { return self.measuraLine(i, n); });
    } else {
      lines = items.map(function (i) { return { id: i.id, quantity: i.quantity, properties: i.properties }; });
    }
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch(this.cfg.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (res) {
      return res.json().then(function (body) { return { ok: res.ok, body: body }; });
    }).then(function (r) {
      if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'The cart didn’t accept these fabrics.');
      document.dispatchEvent(new CustomEvent(ev0 + ':added', { detail: { items: items } }));
      if (self.cfg.afterAdd === 'cart_page') { window.location.href = self.cfg.cartUrl || '/cart'; return; }
      self.message('Added ' + items.length + ' fabrics to your cart. <a href="' + esc(self.cfg.cartUrl || '/cart') + '">View cart</a>');
      btn.disabled = false; btn.textContent = label;
    }).catch(function (err) {
      self.message('<p class="skd-msg-p">' + esc(err.message) + ' Nothing was added. Please try again, or add each fabric from its own page with the amount shown:</p>' +
        self.linkList(items), true);
      btn.disabled = false; btn.textContent = label;
    });
  };
  P.copyLink = function () {
    var url = this.shareUrl(), self = this, btn = this.q('[data-skd-share]');
    function done() { btn.textContent = 'Link copied'; setTimeout(function () { btn.textContent = 'Copy link to this design'; }, 2000); }
    function fallback() { self.message('Copy this link: <input class="skd-search" readonly value="' + esc(url) + '" onclick="this.select()">'); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, fallback);
    else fallback();
  };

  P.bind = function () {
    var self = this, app = this.app;
    app.addEventListener('click', function (e) {
      var t = e.target, el;
      if ((el = t.closest('[data-skd-design]'))) {
        self.state.design = el.getAttribute('data-skd-design');
        var d = self.design(); self.state.active = 'b:' + (d.slots[1] || d.slots[0]).id; self.state.hover = null;
        self.renderAll(); return;
      }
      if ((el = t.closest('[data-skd-slot]'))) {
        self.setActive(el.getAttribute('data-skd-slot'));
        if (window.innerWidth < 990) self.q('.skd-picker').scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if ((el = t.closest('[data-skd-canvas] [data-slot]'))) { self.setActive(el.getAttribute('data-slot')); return; }
      if ((el = t.closest('[data-skd-fabric]'))) { self.setFabric(el.getAttribute('data-skd-fabric')); return; }
      if ((el = t.closest('[data-skd-fam]'))) { self.state.fam = el.getAttribute('data-skd-fam'); self.renderPicker(); return; }
      if ((el = t.closest('[data-skd-holiday]'))) {
        var tag = el.getAttribute('data-skd-holiday');
        self.state.hol = self.state.hol === tag ? '' : tag; // tap again to turn it off
        self.renderPicker(); self.syncUrl(); return;
      }
      if ((el = t.closest('[data-skd-view]'))) { self.state.view = el.getAttribute('data-skd-view'); self.renderAll(); return; }
      if (t.closest('[data-skd-surprise]')) { self.surprise(); return; }
      if (t.closest('[data-skd-reset]')) { self.reset(); return; }
      if (t.closest('[data-skd-add]')) { self.addToCart(); return; }
      if (t.closest('[data-skd-share]')) { self.copyLink(); return; }
    });
    app.addEventListener('change', function (e) {
      var opt = e.target.getAttribute('data-skd-opt');
      if (!opt) return;
      self.state.opt[opt] = e.target.value;
      self.fallback();
      self.renderAll();
    });
    app.addEventListener('input', function (e) {
      if (e.target.hasAttribute('data-skd-search')) { self.state.query = e.target.value; self.renderPicker(); }
    });
    var grid = this.q('[data-skd-grid]');
    grid.addEventListener('mouseover', function (e) {
      var f = e.target.closest('[data-skd-fabric]');
      if (f && self.state.hover !== f.getAttribute('data-skd-fabric')) { self.state.hover = f.getAttribute('data-skd-fabric'); self.renderStage(); }
    });
    grid.addEventListener('mouseleave', function () { if (self.state.hover) { self.state.hover = null; self.renderStage(); } });
  };
  // ===================== end of shared core =====================

  // ===================== stocking designer =====================
  // How a stocking is built:
  //   Front and back are cut from the stocking shape (toe points right, heel on the left, hanging loop at
  //   the top of the heel side). The front is pieced as a panel a little bigger than the shape, then the
  //   shape is cut out. Heel and toe patches are sewn on top of the front. The cuff is one band, sewn into
  //   a loop, folded in half and stitched around the top. Lined stockings have two lining pieces.
  // H = total height, Lw = leg width, F = heel to toe, Fh = foot height, cuff = finished cuff depth.
  var STOCKINGS = {
    mini: { name: 'Mini stocking', H: 10, Lw: 5, F: 8.5, Fh: 4, cuff: 2.5 },
    small: { name: 'Small stocking', H: 14, Lw: 6.5, F: 10.5, Fh: 5, cuff: 3.5 },
    classic: { name: 'Classic stocking', H: 18, Lw: 8, F: 12.5, Fh: 6.5, cuff: 4.5 },
    large: { name: 'Large stocking', H: 22, Lw: 9.5, F: 15, Fh: 7.5, cuff: 5.5 }
  };
  var DEEP = 2;          // a deep cuff is this much deeper than the standard one
  var LOOP = [2, 7];     // hanging loop, cut size (folded in four to ½″ wide)
  var BUILTIN = [{"id":"patchwork-squares","name":"Patchwork Squares","skill":"Beginner","geometry":{"unitW":3,"unitH":3,"slots":[{"id":"a","name":"Squares 1","role":"any"},{"id":"b","name":"Squares 2","role":"dark"},{"id":"c","name":"Squares 3","role":"light"},{"id":"d","name":"Squares 4","role":"any"}],"layout":[[0,1,2,3],[2,3,0,1],[1,2,3,0],[3,0,1,2]],"tiles":[{"pieces":[{"s":"a","p":[[0,0],[3,0],[3,3],[0,3]]}]},{"pieces":[{"s":"b","p":[[0,0],[3,0],[3,3],[0,3]]}]},{"pieces":[{"s":"c","p":[[0,0],[3,0],[3,3],[0,3]]}]},{"pieces":[{"s":"d","p":[[0,0],[3,0],[3,3],[0,3]]}]}]},"defaults":{"a":"RED0315","b":"GRN2311","c":"CRM3322","d":"RED6628","_cuff":"CRM7782","_heeltoe":"RED6601","_back":"GRN0132","_lining":"CRM2953","_loop":"RED6601"},"aliases":["patchwork-squares-stocking"]},{"id":"candy-stripe","name":"Candy Stripe","skill":"Beginner+","geometry":{"unitW":3,"unitH":3,"stripW":1.06,"slots":[{"id":"bg","name":"Background stripe","role":"light"},{"id":"a","name":"Stripe A","role":"any"},{"id":"b","name":"Stripe B","role":"any"}],"layout":[[0,1],[1,0]],"tiles":[{"pieces":[{"s":"bg","p":[[0,0],[1.5,0],[0,1.5]]},{"s":"a","p":[[1.5,0],[3,0],[0,3],[0,1.5]]},{"s":"bg","p":[[3,0],[3,1.5],[1.5,3],[0,3]]},{"s":"b","p":[[3,1.5],[3,3],[1.5,3]]}]},{"pieces":[{"s":"bg","p":[[0,0],[1.5,0],[0,1.5]]},{"s":"b","p":[[1.5,0],[3,0],[0,3],[0,1.5]]},{"s":"bg","p":[[3,0],[3,1.5],[1.5,3],[0,3]]},{"s":"a","p":[[3,1.5],[3,3],[1.5,3]]}]}]},"defaults":{"bg":"CRM2953","a":"RED6601","b":"GRN0132","_cuff":"GRN2311","_heeltoe":"RED6601","_back":"RED6601","_lining":"CRM2953","_loop":"GRN0132"},"aliases":["candy-stripe-stocking"]},{"id":"christmas-trees","name":"Christmas Trees","skill":"Confident beginner","geometry":{"unitW":4,"unitH":5,"slots":[{"id":"sky","name":"Background","role":"light"},{"id":"treeA","name":"Trees A","role":"any"},{"id":"treeB","name":"Trees B","role":"any"},{"id":"trunk","name":"Trunks","role":"dark"}],"layout":[[0,1],[1,0]],"tiles":[{"pieces":[{"s":"treeA","p":[[2,0.5],[3.75,4],[0.25,4]]},{"s":"sky","p":[[0,0],[2,0],[2,0.5],[0.25,4],[0,4]]},{"s":"sky","p":[[2,0],[4,0],[4,4],[3.75,4],[2,0.5]]},{"s":"trunk","p":[[1.5,4],[2.5,4],[2.5,5],[1.5,5]]},{"s":"sky","p":[[0,4],[1.5,4],[1.5,5],[0,5]]},{"s":"sky","p":[[2.5,4],[4,4],[4,5],[2.5,5]]}]},{"pieces":[{"s":"treeB","p":[[2,0.5],[3.75,4],[0.25,4]]},{"s":"sky","p":[[0,0],[2,0],[2,0.5],[0.25,4],[0,4]]},{"s":"sky","p":[[2,0],[4,0],[4,4],[3.75,4],[2,0.5]]},{"s":"trunk","p":[[1.5,4],[2.5,4],[2.5,5],[1.5,5]]},{"s":"sky","p":[[0,4],[1.5,4],[1.5,5],[0,5]]},{"s":"sky","p":[[2.5,4],[4,4],[4,5],[2.5,5]]}]}]},"defaults":{"sky":"CRM7782","treeA":"GRN2311","treeB":"GRN0381","trunk":"BR3428","_cuff":"RED6628","_heeltoe":"RED6601","_back":"RED0315","_lining":"CRM3322","_loop":"RED6601"},"aliases":["christmas-trees-stocking"]},{"id":"diamonds","name":"Diamonds","skill":"Beginner+","geometry":{"unitW":4,"unitH":4,"slots":[{"id":"bg","name":"Background","role":"light"},{"id":"diaA","name":"Diamonds A","role":"any"},{"id":"diaB","name":"Diamonds B","role":"dark"}],"layout":[[0,1],[1,0]],"tiles":[{"pieces":[{"s":"diaA","p":[[2,0],[4,2],[2,4],[0,2]]},{"s":"bg","p":[[0,0],[2,0],[0,2]]},{"s":"bg","p":[[2,0],[4,0],[4,2]]},{"s":"bg","p":[[4,2],[4,4],[2,4]]},{"s":"bg","p":[[0,2],[2,4],[0,4]]}]},{"pieces":[{"s":"diaB","p":[[2,0],[4,2],[2,4],[0,2]]},{"s":"bg","p":[[0,0],[2,0],[0,2]]},{"s":"bg","p":[[2,0],[4,0],[4,2]]},{"s":"bg","p":[[4,2],[4,4],[2,4]]},{"s":"bg","p":[[0,2],[2,4],[0,4]]}]}]},"defaults":{"bg":"CRM2952","diaA":"RED0315","diaB":"GRN0132","_cuff":"CRM7782","_heeltoe":"GRN2311","_back":"RED6601","_lining":"CRM2953","_loop":"GRN2311"},"aliases":["diamonds-stocking"]},{"id":"flying-geese","name":"Flying Geese","skill":"Beginner+","geometry":{"unitW":4,"unitH":2,"slots":[{"id":"sky","name":"Sky (background)","role":"light"},{"id":"geeseA","name":"Geese A","role":"any"},{"id":"geeseB","name":"Geese B","role":"dark"}],"layout":[[0,1],[1,0]],"tiles":[{"pieces":[{"s":"geeseA","p":[[0,2],[2,0],[4,2]]},{"s":"sky","p":[[0,0],[2,0],[0,2]]},{"s":"sky","p":[[2,0],[4,0],[4,2]]}]},{"pieces":[{"s":"geeseB","p":[[0,2],[2,0],[4,2]]},{"s":"sky","p":[[0,0],[2,0],[0,2]]},{"s":"sky","p":[[2,0],[4,0],[4,2]]}]}]},"defaults":{"sky":"CRM2952","geeseA":"RED6601","geeseB":"GRN2311","_cuff":"RED6628","_heeltoe":"GRN2311","_back":"GRN2311","_lining":"CRM3322","_loop":"RED6601"},"aliases":["flying-geese-stocking"]},{"id":"feature-print","name":"Feature Print","skill":"Easiest","geometry":{"unitW":3,"unitH":3,"plain":true,"slots":[{"id":"main","name":"Main print","role":"any"}],"layout":[[0]],"tiles":[{"pieces":[{"s":"main","p":[[0,0],[3,0],[3,3],[0,3]]}]}]},"defaults":{"main":"GRN2311","_cuff":"CRM7782","_heeltoe":"RED6601","_back":"GRN2311","_lining":"RED0315","_loop":"RED6601"},"aliases":["feature-print-stocking"]}];

  function mod(a, n) { return ((a % n) + n) % n; }
  function r2(v) { return Math.round(v * 100) / 100; }

  function prepGeometry(g) {
    g = parseJson(g);
    if (!g) return null;
    var slots = normSlots(g.slots);
    if (!slots || !Array.isArray(g.tiles) || !g.tiles.length) return null;
    var tiles = g.tiles.map(function (t) { return t && t.pieces; });
    if (!tiles.every(validPieces)) return null;
    var nT = tiles.length;
    var layout = Array.isArray(g.layout) && g.layout.length && g.layout.every(Array.isArray) ? g.layout : [[0]];
    layout = layout.map(function (row) { return row.map(function (v) { return Math.max(0, Math.min(nT - 1, Number(v) || 0)); }); });
    return {
      uW: Number(g.unitW) || 4, uH: Number(g.unitH) || 4, plain: !!g.plain, slots: slots, tiles: tiles, layout: layout,
      stripW: Number(g.stripW) || 0 // strip-pieced designs: pieces run on as continuous strips
    };
  }

  P.tileAt = function (des, r, c) {
    var row = des.layout[mod(r, des.layout.length)];
    return des.tiles[row[mod(c, row.length)]];
  };
  // Shape measurements for one size (used by the main drawing and the design thumbnails).
  function shape(z, cuffH) {
    var H = z.H, Lw = z.Lw, F = z.F, Fh = z.Fh, yA = H - Fh, r = Fh / 2;
    var rh = Math.min(Fh * 0.55, Lw * 0.45), c = Math.min(0.8, (F - r - Lw) / 2);
    var hw = r2(Lw * 0.42), hh = r2(Fh * 0.68), tw = r2(Fh * 0.56);
    return {
      H: H, Lw: Lw, F: F, Fh: Fh, yA: yA, r: r, rh: rh, cuffH: cuffH, hw: hw, hh: hh, tw: tw,
      outline: 'M0 0L' + Lw + ' 0L' + Lw + ' ' + (yA - c) + 'C' + Lw + ' ' + (yA - c * 0.2) + ' ' + (Lw + c * 0.2) + ' ' + yA + ' ' + (Lw + c) + ' ' + yA +
        'L' + (F - r) + ' ' + yA + 'A' + r + ' ' + r + ' 0 0 1 ' + (F - r) + ' ' + H + 'L' + rh + ' ' + H + 'A' + rh + ' ' + rh + ' 0 0 1 0 ' + (H - rh) + 'Z',
      heel: 'M0 ' + (H - hh) + 'C' + hw * 0.6 + ' ' + (H - hh) + ' ' + hw + ' ' + (H - hh * 0.5) + ' ' + hw + ' ' + H + 'L-1 ' + (H + 1) + 'L-1 ' + (H - hh) + 'Z',
      heelLine: 'M0 ' + (H - hh) + 'C' + hw * 0.6 + ' ' + (H - hh) + ' ' + hw + ' ' + (H - hh * 0.5) + ' ' + hw + ' ' + H,
      toe: 'M' + (F - tw) + ' ' + yA + 'C' + (F - tw - Fh * 0.14) + ' ' + (yA + Fh * 0.3) + ' ' + (F - tw - Fh * 0.14) + ' ' + (H - Fh * 0.3) + ' ' + (F - tw) + ' ' + H +
        'L' + (F + 1) + ' ' + (H + 1) + 'L' + (F + 1) + ' ' + (yA - 1) + 'Z',
      toeLine: 'M' + (F - tw) + ' ' + yA + 'C' + (F - tw - Fh * 0.14) + ' ' + (yA + Fh * 0.3) + ' ' + (F - tw - Fh * 0.14) + ' ' + (H - Fh * 0.3) + ' ' + (F - tw) + ' ' + H
    };
  }
  // Which pattern tiles are needed to cover the stocking (with ½″ to spare all round).
  function tilesFor(des, sh) {
    var ox = (sh.Lw - Math.ceil(sh.Lw / des.uW - 1e-9) * des.uW) / 2, oy = sh.cuffH, out = [];
    var c0 = Math.floor((-0.5 - ox) / des.uW), c1 = Math.ceil((sh.F + 0.5 - ox) / des.uW);
    var r0 = Math.floor((-0.5 - oy) / des.uH), r1 = Math.ceil((sh.H + 0.5 - oy) / des.uH);
    function hit(x, y, X0, Y0, X1, Y1) { return x < X1 && x + des.uW > X0 && y < Y1 && y + des.uH > Y0; }
    for (var r = r0; r < r1; r++) for (var c = c0; c < c1; c++) {
      var x = ox + c * des.uW, y = oy + r * des.uH;
      if (hit(x, y, -0.5, -0.5, sh.Lw + 0.5, sh.H + 0.5) || hit(x, y, -0.5, sh.yA - 0.5, sh.F + 0.5, sh.H + 0.5)) out.push({ r: r, c: c, x: x, y: y });
    }
    return out;
  }

  P.stockingDims = function () {
    var z = STOCKINGS[this.opt('size')] || STOCKINGS.classic, cuffOpt = this.opt('cuff') || 'std';
    var cuffH = cuffOpt === 'none' ? 0 : z.cuff + (cuffOpt === 'deep' ? DEEP : 0);
    var sh = shape(z, cuffH);
    sh.z = z;
    sh.label = z.name.toLowerCase();
    sh.qty = Number(this.opt('qty')) || 1;
    sh.heelToe = (this.opt('heeltoe') || 'on') === 'on';
    sh.backMatch = this.opt('back') === 'match';
    sh.lined = this.opt('lining') !== 'unlined';
    sh.tiles = tilesFor(this.design(), sh);
    sh.cuffCutW = 2 * z.Lw + 1.5;      // around the top, with a little ease and ¼″ seams
    sh.cuffCutH = 2 * cuffH + 0.5;      // folded in half
    sh.heelCut = [sh.hw + 0.5, sh.hh + 0.5];
    sh.toeCut = [r2(sh.tw + sh.Fh * 0.14) + 0.5, sh.Fh + 0.5];
    return sh;
  };

  // The front (pieced or plain) in stocking coordinates.
  P.bodySVG = function (clickable, fabOf) {
    var self = this, des = this.design(), d = this.dims(), o = '', sel = '';
    if (des.plain) {
      var k0 = 'b:' + des.slots[0].id;
      o += '<rect x="-.5" y="-.5" width="' + (d.F + 1) + '" height="' + (d.H + 1) + '" fill="' + this.fill(fabOf ? fabOf(des.slots[0].id) : this.keyFor(k0)) + '"' + (clickable ? ' data-slot="' + k0 + '"' : '') + '/>';
      if (clickable && this.state.active === k0) sel += '<path d="' + d.outline + '" ' + this.selStroke(0.15) + '/>';
      return { body: o, sel: sel };
    }
    d.tiles.forEach(function (t) {
      var p = self.piecesSVG(self.tileAt(des, t.r, t.c), t.x, t.y, { click: clickable, fabOf: fabOf, selW: 0.1 });
      o += p.body; sel += p.sel;
    });
    return { body: o, sel: sel };
  };
  // Numbered markers: each fabric gets a spot down the visible part of the leg.
  P.stockingBadges = function () {
    var self = this, des = this.design(), d = this.dims(), best = {}, o = '';
    var top = d.cuffH + 0.6, n = des.slots.length;
    function visible(x, y) {
      var inLeg = x > 0.6 && x < d.Lw - 0.6 && y > top && y < d.H - 0.6;
      var inFoot = x > 0.6 && x < d.F - d.r && y > d.yA + 0.6 && y < d.H - 0.6;
      if (!(inLeg || inFoot)) return false;
      if (d.heelToe && ((x < d.hw + 0.4 && y > d.H - d.hh - 0.4) || (x > d.F - d.tw - d.Fh * 0.3 && y > d.yA - 0.4))) return false;
      return true;
    }
    if (des.plain) return this.badge(d.Lw / 2, (top + d.yA) / 2, 1, 0.55);
    var idx = {};
    des.slots.forEach(function (sl, i) { idx[sl.id] = i; });
    d.tiles.forEach(function (t) {
      self.tileAt(des, t.r, t.c).forEach(function (pc) {
        var cc = centroid(pc.p), pt = [cc[0] + t.x, cc[1] + t.y];
        if (!visible(pt[0], pt[1])) return;
        var aimY = top + (d.yA - top) * (idx[pc.s] + 1) / (n + 1);
        var a = area(pc.p), dist = Math.hypot(pt[0] - d.Lw / 2, pt[1] - aimY), b = best[pc.s];
        if (!b || a > b.a * 1.1 || (a > b.a * 0.9 && dist < b.dist)) best[pc.s] = { a: Math.max(a, b ? b.a : 0), c: pt, dist: dist };
      });
    });
    des.slots.forEach(function (sl, k) { if (best[sl.id]) o += self.badge(best[sl.id].c[0], best[sl.id].c[1], k + 1, 0.5); });
    return o;
  };
  P.loopSVG = function () {
    var p = 'M.45 .6C.45 -2.4 1.75 -2.4 1.75 .6', key = 'q:loop', o = '';
    o += '<path d="' + p + '" fill="none" stroke="rgba(0,0,0,.35)" stroke-width=".6"/>';
    o += '<path d="' + p + '" fill="none" stroke="' + this.fill(this.keyFor(key)) + '" stroke-width=".48" data-slot="' + key + '"/>';
    if (this.state.active === key) o += '<path d="' + p + '" ' + this.selStroke(0.12) + '/>';
    return o;
  };
  // Finished stocking, front view.
  P.stockingSVG = function () {
    var des = this.design(), d = this.dims(), s = this.state, id = this.sid, act = s.active;
    var m = 2.4, X0 = -m, Y0 = -3.6, X1 = d.F + m, Y1 = d.H + m;
    var fs = 'font-size="' + Math.max(0.6, d.H * 0.034) + '"';
    var o = '<svg viewBox="' + X0 + ' ' + Y0 + ' ' + (X1 - X0) + ' ' + (Y1 - Y0) + '" role="img" aria-label="' + esc(des.name + ' ' + d.label + ', ' + d.H + ' inches tall') + '">';
    o += '<defs><clipPath id="skd-' + id + '-out"><path d="' + d.outline + '"/></clipPath></defs>';
    o += this.mat(X0, Y0, X1 - X0, Y1 - Y0, 1, 6);
    o += this.loopSVG();
    o += '<path d="' + d.outline + '" transform="translate(.35 .45)" fill="rgba(0,0,0,.28)"/>';
    var body = this.bodySVG(true);
    o += '<g clip-path="url(#skd-' + id + '-out)">' + body.body;
    if (d.heelToe) {
      var hf = this.fill(this.keyFor('q:heeltoe'));
      o += '<path d="' + d.heel + '" fill="' + hf + '" data-slot="q:heeltoe"/><path d="' + d.toe + '" fill="' + hf + '" data-slot="q:heeltoe"/>';
    }
    o += body.sel;
    if (d.heelToe && act === 'q:heeltoe') o += '<path d="' + d.heel + '" ' + this.selStroke(0.14) + '/><path d="' + d.toe + '" ' + this.selStroke(0.14) + '/>';
    if (d.cuffH > 0) o += '<rect x="-1" y="' + d.cuffH + '" width="' + (d.F + 2) + '" height=".45" fill="rgba(0,0,0,.22)" pointer-events="none"/>';
    o += '</g>';
    if (d.heelToe) {
      var st = 'fill="none" stroke="rgba(20,20,20,.45)" stroke-width=".05" stroke-dasharray=".22 .16" pointer-events="none"';
      o += '<path d="' + d.heelLine + '" ' + st + '/><path d="' + d.toeLine + '" ' + st + '/>';
    }
    o += '<path d="' + d.outline + '" fill="none" stroke="rgba(0,0,0,.4)" stroke-width=".08" pointer-events="none"/>';
    if (d.cuffH > 0) {
      o += '<rect x="-.35" y="-.15" width="' + (d.Lw + 0.7) + '" height="' + (d.cuffH + 0.15) + '" rx=".25" fill="' + this.fill(this.keyFor('q:cuff')) + '" stroke="rgba(0,0,0,.4)" stroke-width=".07" data-slot="q:cuff"/>';
      if (act === 'q:cuff') o += '<rect x="-.2" y="0" width="' + (d.Lw + 0.4) + '" height="' + (d.cuffH - 0.15) + '" ' + this.selStroke(0.14) + '/>';
    }
    o += this.stockingBadges();
    o += '<text x="' + (-m * 0.5) + '" y="' + d.H / 2 + '" ' + LABEL + ' ' + fs + ' transform="rotate(-90 ' + (-m * 0.5) + ' ' + d.H / 2 + ')">' + inch(d.H) + ' tall</text>';
    o += '<text x="' + d.F / 2 + '" y="' + (d.H + m * 0.62) + '" ' + LABEL + ' ' + fs + '>' + inch(d.F) + ' heel to toe</text>';
    if (d.cuffH > 0) o += '<text x="' + (d.Lw + 0.8) + '" y="' + (d.cuffH / 2 + 0.3) + '" ' + LABEL.replace('middle', 'start') + ' ' + fs + '>' + inch(d.cuffH) + ' cuff</text>';
    if (d.qty > 1) o += '<text x="' + (X1 - 0.6) + '" y="' + (Y0 + 1.6) + '" ' + LABEL.replace('middle', 'end') + ' ' + fs + '>×' + d.qty + '</text>';
    return o + '</svg>';
  };

  // Cutting layout: front panel, back, lining, then cuff, heel, toe and loop.
  P.cutSVG = function () {
    var self = this, des = this.design(), d = this.dims(), s = this.state, id = this.sid, act = s.active;
    var PW = d.F + 1, PH = d.H + 1, gap = 2.5, m = 3, N = d.qty;
    var fz = Math.max(0.7, PW * 0.05), fs = 'font-size="' + fz + '"', small = 'font-size="' + fz * 0.85 + '"';
    var cols = d.lined ? 3 : 2, row1W = cols * PW + (cols - 1) * gap;
    var y2 = PH + gap + 0.6;
    var parts = [];
    if (d.cuffH > 0) parts.push({ k: 'cuff', w: d.cuffCutW, h: d.cuffCutH });
    if (d.heelToe) { parts.push({ k: 'heel', w: d.heelCut[0], h: d.heelCut[1] }); parts.push({ k: 'toe', w: d.toeCut[0], h: d.toeCut[1] }); }
    parts.push({ k: 'loop', w: LOOP[1], h: LOOP[0] });
    var x = 0, row2H = 0;
    parts.forEach(function (p) { p.x = x; x += p.w + gap; row2H = Math.max(row2H, p.h); });
    var VW = Math.max(row1W, x - gap), VH = y2 + row2H + 2.2;
    var o = '<svg viewBox="' + (-m) + ' ' + (-m) + ' ' + (VW + 2 * m) + ' ' + (VH + 2 * m) + '" role="img" aria-label="' + esc(des.name + ' cutting layout') + '">';
    o += '<defs><clipPath id="skd-' + id + '-panel"><rect x="-.5" y="-.5" width="' + PW + '" height="' + PH + '"/></clipPath></defs>';
    o += this.mat(-m, -m, VW + 2 * m, VH + 2 * m, 1, 6);
    var cutLine = 'fill="none" stroke="#fff" stroke-width=".1" stroke-dasharray=".4 .25" pointer-events="none"';
    var cutUnder = 'fill="none" stroke="rgba(0,0,0,.45)" stroke-width=".2" pointer-events="none"';
    function shadow(px, py, w, h) { return '<rect x="' + (px + 0.15) + '" y="' + (py + 0.2) + '" width="' + w + '" height="' + h + '" fill="rgba(0,0,0,.28)"/>'; }
    function label(px, w, py, text) { return '<text x="' + (px + w / 2) + '" y="' + py + '" ' + LABEL + ' ' + fs + '>' + text + '</text>'; }
    // front
    var body = this.bodySVG(true);
    o += shadow(0, 0, PW, PH);
    o += '<g transform="translate(.5 .5)"><g clip-path="url(#skd-' + id + '-panel)">' + body.body + body.sel + '</g><path d="' + d.outline + '" ' + cutLine + '/></g>';
    o += label(0, PW, -m * 0.3, 'Front, cut ' + N);
    // back (reversed so the stockings match)
    var bx = PW + gap, mir = 'translate(' + (bx + 0.5 + d.F) + ' .5) scale(-1 1)';
    o += shadow(bx, 0, PW, PH);
    if (d.backMatch) {
      o += '<g transform="' + mir + '"><g clip-path="url(#skd-' + id + '-panel)">' + body.body + body.sel + '</g></g>';
    } else {
      o += '<rect x="' + bx + '" y="0" width="' + PW + '" height="' + PH + '" fill="' + this.fill(this.keyFor('q:back')) + '" data-slot="q:back"/>';
      if (act === 'q:back') o += '<rect x="' + (bx + 0.1) + '" y=".1" width="' + (PW - 0.2) + '" height="' + (PH - 0.2) + '" ' + this.selStroke(0.15) + '/>';
    }
    o += '<g transform="' + mir + '"><path d="' + d.outline + '" ' + cutLine + '/></g>';
    o += label(bx, PW, -m * 0.3, 'Back, reversed, cut ' + N);
    // lining
    if (d.lined) {
      var lx = 2 * (PW + gap);
      o += shadow(lx, 0, PW, PH);
      o += '<rect x="' + lx + '" y="0" width="' + PW + '" height="' + PH + '" fill="' + this.fill(this.keyFor('q:lining')) + '" data-slot="q:lining"/>';
      if (act === 'q:lining') o += '<rect x="' + (lx + 0.1) + '" y=".1" width="' + (PW - 0.2) + '" height="' + (PH - 0.2) + '" ' + this.selStroke(0.15) + '/>';
      o += '<g transform="translate(' + (lx + 0.5) + ' .5)"><path d="' + d.outline + '" ' + cutLine + '/></g>';
      o += label(lx, PW, -m * 0.3, 'Lining, cut ' + 2 * N + ' (half reversed)');
    }
    o += '<text x="' + (-m * 0.45) + '" y="' + PH / 2 + '" ' + LABEL + ' ' + fs + ' transform="rotate(-90 ' + (-m * 0.45) + ' ' + PH / 2 + ')">' + inch(PH) + '</text>';
    o += '<text x="' + PW / 2 + '" y="' + (PH + 1.3) + '" ' + LABEL + ' ' + small + '>' + inch(PW) + ' wide</text>';
    // small parts
    parts.forEach(function (p) {
      var key = p.k === 'heel' || p.k === 'toe' ? 'q:heeltoe' : 'q:' + p.k, px = p.x, py = y2;
      o += shadow(px, py, p.w, p.h);
      o += '<rect x="' + px + '" y="' + py + '" width="' + p.w + '" height="' + p.h + '" fill="' + self.fill(self.keyFor(key)) + '" data-slot="' + key + '"/>';
      if (act === key) o += '<rect x="' + (px + 0.08) + '" y="' + (py + 0.08) + '" width="' + (p.w - 0.16) + '" height="' + (p.h - 0.16) + '" ' + self.selStroke(0.12) + '/>';
      var fold = 'stroke="rgba(20,20,20,.4)" stroke-width=".06" stroke-dasharray=".3 .2" pointer-events="none"';
      var txt;
      if (p.k === 'cuff') {
        o += '<path d="M' + px + ' ' + (py + p.h / 2) + 'H' + (px + p.w) + '" ' + fold + '/>';
        txt = 'Cuff ' + inch(p.w) + ' × ' + inch(p.h) + ', cut ' + N;
      } else if (p.k === 'loop') {
        o += '<path d="M' + px + ' ' + (py + p.h / 2) + 'H' + (px + p.w) + '" ' + fold + '/>';
        txt = 'Loop, cut ' + N;
      } else if (p.k === 'heel') {
        o += '<g transform="translate(' + (px + 0.25) + ' ' + (py + 0.25 - (d.H - d.hh)) + ')"><path d="' + d.heelLine + 'L0 ' + d.H + 'Z" ' + cutLine + '/></g>';
        txt = 'Heel, cut ' + N;
      } else {
        var tx = px + 0.25 - (d.F - d.tw - d.Fh * 0.14), ty = py + 0.25 - d.yA;
        o += '<g transform="translate(' + tx + ' ' + ty + ')"><path d="' + d.toeLine + 'L' + (d.F - d.tw - d.Fh * 0.14 + p.w - 0.5) + ' ' + d.H + 'L' + (d.F - d.tw - d.Fh * 0.14 + p.w - 0.5) + ' ' + d.yA + 'Z" ' + cutLine + '/></g>';
        txt = 'Toe, cut ' + N;
      }
      o += '<text x="' + (px + p.w / 2) + '" y="' + (py + p.h + 1.3) + '" ' + LABEL + ' ' + small + '>' + txt + '</text>';
    });
    // dark edge under every dashed cut line, so it shows on light and dark fabrics
    o = o.replace(/<path d="([^"]*)" (fill="none" stroke="#fff"[^>]*)\/>/g, '<path d="$1" ' + cutUnder + '/><path d="$1" $2/>');
    return o + '</svg>';
  };

  var SPEC = {
    noun: 'stocking', param: 'stocking', event: 'stockingdesigner', propLabel: 'Stocking design',
    designsLabel: 'Stocking designs', qTitle: 'Stocking parts',
    hint: 'Click any part of the stocking to choose its fabric. Prints are shown at approximate real size. Screen colors vary from the actual fabric.',
    views: [['stocking', 'Finished stocking'], ['cut', 'Cutting layout']], defaultView: 'stocking',
    builtin: BUILTIN, prepGeometry: prepGeometry,
    options: [
      { id: 'size', label: 'Size', cfgKey: 'defaultSize', dflt: 'classic', opts: function () {
        return Object.keys(STOCKINGS).map(function (k) { return [k, STOCKINGS[k].name.replace(' stocking', '') + ' · ' + inch(STOCKINGS[k].H) + ' tall']; });
      } },
      { id: 'cuff', label: 'Cuff', dflt: 'std', opts: [['std', 'Standard'], ['deep', 'Deep'], ['none', 'No cuff']] },
      { id: 'heeltoe', label: 'Heel & toe', dflt: 'on', opts: [['on', 'Contrast'], ['off', 'None']] },
      { id: 'back', label: 'Back', dflt: 'plain', opts: [['plain', 'Plain fabric'], ['match', 'Same as front']] },
      { id: 'lining', label: 'Lining', dflt: 'lined', opts: [['lined', 'Lined'], ['unlined', 'Unlined']] },
      { id: 'qty', label: 'How many', dflt: '1', opts: [['1', '1 stocking'], ['2', '2 stockings'], ['3', '3 stockings'], ['4', '4 stockings'], ['5', '5 stockings'], ['6', '6 stockings']] }
    ],
    qslots: [
      { id: 'cuff', name: 'Cuff', from: 'light', off: 'No cuff', on: function () { return this.dims().cuffH > 0; } },
      { id: 'heeltoe', name: 'Heel & toe', from: 'second', off: 'No heel & toe', on: function () { return this.dims().heelToe; } },
      { id: 'back', name: 'Back', from: 'dark', off: 'Back matches the front', on: function () { return !this.dims().backMatch; } },
      { id: 'lining', name: 'Lining', from: 'light', off: 'Unlined', on: function () { return this.dims().lined; } },
      { id: 'loop', name: 'Hanging loop', from: 'second' }
    ],
    dims: function () { return this.stockingDims(); },
    yardage: function (y) {
      var d = this.dims(), des = this.design(), self = this, N = d.qty, fronts = d.backMatch ? 2 * N : N, cut = {};
      if (des.plain) {
        y.put('b:' + des.slots[0].id, y.rects(d.F + 0.5, d.H + 0.5, fronts));
      } else {
        var k = des.stripW ? (des.stripW + 0.5) / des.stripW : 0;
        d.tiles.forEach(function (t) {
          self.tileAt(des, t.r, t.c).forEach(function (pc) { cut[pc.s] = (cut[pc.s] || 0) + (k ? area(pc.p) * k : cutArea(pc.p)); });
        });
        des.slots.forEach(function (sl) { if (cut[sl.id]) y.pieced('b:' + sl.id, fronts * cut[sl.id]); });
      }
      if (!d.backMatch) y.put('q:back', y.rects(d.F + 0.5, d.H + 0.5, N));
      if (d.lined) y.put('q:lining', y.rects(d.F + 0.5, d.H + 0.5, 2 * N));
      if (d.cuffH > 0) y.put('q:cuff', y.rects(d.cuffCutW, d.cuffCutH, N));
      if (d.heelToe) {
        y.put('q:heeltoe', y.rects(d.heelCut[0], d.heelCut[1], N));
        y.put('q:heeltoe', y.rects(d.toeCut[0], d.toeCut[1], N));
      }
      y.put('q:loop', y.rects(LOOP[0], LOOP[1], N));
    },
    render: function (view) { return view === 'cut' ? this.cutSVG() : this.stockingSVG(); },
    miniSVG: function (des) {
      var f = this.state.fab[des.id], sh = shape(STOCKINGS.classic, STOCKINGS.classic.cuff), self = this;
      var cid = 'skd-' + this.sid + '-m-' + String(des.id).replace(/[^\w-]/g, '');
      var o = '<svg viewBox="-2.75 -1 18 20" aria-hidden="true" focusable="false"><defs><clipPath id="' + cid + '"><path d="' + sh.outline + '"/></clipPath></defs>';
      o += '<g clip-path="url(#' + cid + ')">';
      if (des.plain) o += '<rect x="-1" y="-1" width="15" height="21" fill="' + this.fill(f[des.slots[0].id]) + '"/>';
      else tilesFor(des, sh).forEach(function (t) { o += self.piecesSVG(self.tileAt(des, t.r, t.c), t.x, t.y, { fabOf: function (sid) { return f[sid]; }, seam: 0.06 }).body; });
      o += '</g><path d="' + sh.outline + '" fill="none" stroke="rgba(0,0,0,.35)" stroke-width=".12"/>';
      o += '<rect x="-.35" y="-.15" width="' + (sh.Lw + 0.7) + '" height="' + (sh.cuffH + 0.15) + '" rx=".25" fill="' + this.fill(this.state.q.cuff) + '" stroke="rgba(0,0,0,.35)" stroke-width=".1"/>';
      return o + '</svg>';
    },
    sizeText: function () {
      var d = this.dims();
      return d.z.name + ', ' + inch(d.H) + ' tall' + (d.qty > 1 ? ', ×' + d.qty : '');
    },
    sizeHead: function () {
      var d = this.dims();
      return '<b>' + inch(d.H) + ' tall × ' + inch(d.F) + ' heel to toe</b> · ' + d.label + (d.cuffH > 0 ? ' · ' + inch(d.cuffH) + ' cuff' : '') + (d.qty > 1 ? ' · ×' + d.qty : '');
    },
    extraNote: function () {
      var d = this.dims();
      return 'You’ll also need (not in this list): thin batting or fusible fleece for the front and back of each stocking, each ' +
        inch(d.F + 1) + ' × ' + inch(d.H + 1) + ', and thread. Names, trims and bells aren’t included.';
    },
    fineText: function () {
      var d = this.dims();
      return 'Front, back' + (d.lined ? ' and lining' : '') + ' are cut from ' + inch(d.F + 0.5) + ' × ' + inch(d.H + 0.5) + ' pieces' +
        (this.design().plain ? '' : ' (the pieced front from a panel a little bigger)') + '; the back is reversed.' +
        (d.cuffH > 0 ? ' The cuff is one band ' + inch(d.cuffCutW) + ' long, sewn into a loop and folded in half.' : '') +
        (d.heelToe ? ' Heel and toe patches are sewn on top of the front.' : '');
    },
    surpriseFinish: function (h) {
      var s = this.state;
      s.q.cuff = h.take(h.pools.light);
      s.q.heeltoe = h.any(h.accents, s.q.cuff);
      s.q.back = h.take(h.pools.dark);
      s.q.lining = Math.random() < 0.5 ? s.q.cuff : h.take(h.pools.mid);
      s.q.loop = s.q.heeltoe;
    }
  };

  // ---------- boot ----------
  function init(scope) {
    (scope || document).querySelectorAll('[data-stocking-designer]').forEach(function (root) {
      if (root.__skd) return;
      root.__skd = new Designer(root, SPEC);
    });
  }
  window.StockingDesigner = Designer;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Theme editor: re-run when the section is added or its settings change.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
